// removed by extract-text-webpack-plugin
module.exports = {"wrapper-actions":"magazines_15v_f","wrapper-actions__divider":"magazines_1qWUS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Heade/components/Actions/styles.scss
// module id = 1002
// module chunks = 1